import React from 'react';
import LandingPageHead from '../../component/LandingPageHead';
import LandingPageBody from '../../component/LandingPageBody';
import './index.css';

class LandingContainer extends React.Component {
  render() {
    return (
      <React.Fragment>
        <LandingPageHead />
        {/* <HeadComponent/> */}
        <LandingPageBody />
        {/* <ProjectContainer /> */}
      </React.Fragment>
    );
  }
}

export default LandingContainer;
